// ------------------------------------------
// お問い合わせ確認画面：「入力画面へ戻る」ボタン
// プラグイン側が相対URL設定時に戻るボタンを非表示にしてしまうため、明示的に表示・遷移させる
// ------------------------------------------
class ContactConfirm {
  constructor(el) {
    this.btn = document.querySelector(el);
    if (this.btn) {
      this.init();
    }
  }

  init() {
    this.btn.style.setProperty('display', 'block', 'important');
    this.btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = '/contact/';
    }, true);
  }
}
